import React, { useState } from 'react';
import EventPartnerModal from '../Common/EventPartnerModal/EventPartnerModal';
import './EventPartner.scss';

const EventPartner = ({
  eventPartner,
  isAllEventPartners,
  isCreativeCommunity,
  isIndustryExperts = false
}) => {

  const [open, setOpen] = useState(false);

  const {
    partnerHeroImages,
    partnerLogo,
    partnerName,
    partnerSpeciality,
    partnerCountry,
    communityProfileLink
  } = eventPartner;

  const closeEventModal = () => {
    setOpen(false);
  }

  const partnerSpecialityTags = partnerSpeciality?.length ? [...partnerSpeciality].splice(0, 2) : [];
  const moreSpeciality = (partnerSpeciality || []).length > 2;

  return (
    <>
      <div className={`community-event-partner-container ${isIndustryExperts ? 'industry-experts' : ''}`} role="presentation" onKeyDown={()=>setOpen(true)} onClick={()=>setOpen(true)}>
        <div className="community-event-partner-image" style={{ backgroundImage: `url(${partnerHeroImages[0].file.url})` }}>
        </div>
        <div className="community-event-partner-details">
          {
            !isIndustryExperts && 
            <div
              className="community-event-partner-logo-image"
              style={{ backgroundImage: `url(${partnerLogo?.file?.url})` }}
            />
          }
          <div className="community-event-partner-details-title">
            <div className="community-event-partner-details-company">
              {partnerName}
            </div>
            <div className="community-event-partner-details-location">
              {partnerCountry}
            </div>
            {
              isIndustryExperts && <>
                <div className="border" />
                <span className="industry-expert-speciality"> Specialises in... </span>
              </>
            }
          </div>
          <div className="community-event-partner-details-tags">
            {
              partnerSpecialityTags?.map((tags, idx) => {
                return <span className={`${partnerSpecialityTags.length === 1 ? 'single-tag' : ''}`} key={`event-partner-${idx}`}>{tags}</span>
              })
            }
            <div className="industry-expert-speciality"> 
              { moreSpeciality && `+ ${[...partnerSpeciality].length - 2} More` }
            </div>
          </div>
        </div>
      </div>
      {
        open && <EventPartnerModal
          isOpen={open}
          onClose={closeEventModal}
          eventPartner={eventPartner}
          isAllEventPartners={isAllEventPartners}
          isCreativeCommunity={isCreativeCommunity}
          communityProfileLink={communityProfileLink}
          isIndustryExperts={isIndustryExperts}
        />
      }
    </>
  )
}

export default EventPartner;
